import { ThinkingFace, HollowRedCircle, CrossMark, MoneyMouthFace, SmilingFaceWithOpenHands } from 'react-blobmoji';
import * as React from 'react';
export default {
  ThinkingFace,
  HollowRedCircle,
  CrossMark,
  MoneyMouthFace,
  SmilingFaceWithOpenHands,
  React
};